export default __webpack_public_path__ + "static/media/1419.00d3437e.png";